import React, { Dispatch, FC, SetStateAction } from 'react';

import TranslationExamples from './TranslationExamples';
import Dictionary from './Dictionary';

import { TranslationType } from 'queries/types/TranslationsResultType';

import './Translation.scss';

type TranslationProps = {
  data: TranslationType | null;
  setData: Dispatch<SetStateAction<TranslationType | null>>;
};

const Translation: FC<TranslationProps> = ({ data, setData }) => (
  <div className={'translation'} id="translation">
    <div className={'translation__sub-box'}>
      <div className={'translation__main-data'}>
        <div className={'translation__main-data-item'}>
          <div style={{ marginRight: '18px' }} className={'translation__main-data-title'}>
            Language:
          </div>{' '}
          <p className={'translation__main-data-text'}>{data?.language}</p>
        </div>
        <div className={'translation__main-data-item'}>
          <div style={{ marginRight: '6px' }} className={'translation__main-data-title'}>
            Updated By:
          </div>{' '}
          <p className={'translation__main-data-text'}>{data?.updated_by}</p>
        </div>
        <div className={'translation__main-data-item'}>
          <div style={{ marginRight: '6px' }} className={'translation__main-data-title'}>
            Last Update:
          </div>{' '}
          <p className={'translation__main-data-text'}>
            {new Date(data?.last_updated || '').toString().split('(')[0]}
          </p>
        </div>
      </div>
      <TranslationExamples data={data} setData={setData} />
    </div>
    <div className={'translation__separator'} />
    <div className={'translation__sub-box'}>
      <Dictionary data={data} setData={setData} />
    </div>
  </div>
);

export default Translation;
